import analytics from 'shared/utils/analytics'

// @vue/component
const colorTheme = {
	mounted() {
		if (!localStorage) return
		if (localStorage.theme === 'light') {
			this.applyLightTheme()
			return
		}
		this.applyDarkTheme()
	},
	methods: {
		toggleTheme() {
			if (this.$store.theme === 'light') {
				this.applyDarkTheme()
			} else {
				this.applyLightTheme()
			}
			analytics.track('Theme Switched', {newTheme: this.$store.theme})
			if (!this.$store.user?.id) return
			analytics.identify(this.$store.user.id, {uiTheme: this.$store.theme})
		},
		applyDarkTheme() {
			document.documentElement.classList.add('dark')
			document.querySelector('meta[name="color-scheme"]').setAttribute('content', 'dark')
			this.$store.theme = 'dark'
			if (localStorage) localStorage.theme = 'dark'
		},
		applyLightTheme() {
			document.documentElement.classList.remove('dark')
			document.querySelector('meta[name="color-scheme"]').setAttribute('content', 'light')
			this.$store.theme = 'light'
			if (localStorage) localStorage.theme = 'light'
		},
	},
}

export default colorTheme
